import React, { useEffect, useRef, useState } from 'react';
import { load } from '@cashfreepayments/cashfree-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function CashfreeGold() {
    const hasCalled = useRef(false);
    let ORDER = ""
    const navigation = useNavigate()
    let cashfree;
    let initializeSDK = async function () {
        cashfree = await load({
            mode: "production"
            // mode: "sandbox"
        });
    };
    initializeSDK()

    const [orderId, setOrderId] = useState(null)
    const [responseObject, setResponseObject] = useState(null)




    useEffect(() => {
        if (hasCalled.current) return; // Prevent second call
        hasCalled.current = true;

        const params = new URL(window.location.href).searchParams;
        const userId = params.get("userid");
        const planId = params.get("plan_id");
        const currency_code = params.get("currency_code");
        const currency_symbol = params.get("currency_symbol");
        const movie = params.get("movie");
        const series = params.get("series");
        const credit_type = params.get("credit_type");
        // const payment_amount = params.get("payment_amount");
        // const deviceType = params.get("device_type");
        // const deviceId = params.get("device_id");

        console.log("Parameters", userId, planId, currency_code, currency_symbol, movie, series, credit_type);
        if (userId && planId) {
            paymentInitiateCashfree(userId, planId, currency_code, currency_symbol, movie, series, credit_type);
        }
    }, []);

    const paymentInitiateCashfree = async (userId, planId, currency_code, currency_symbol, movie, series, credit_type) => {
        try {
            const resData = await axios.post('https://prmgold.thehnstore.com/api/payment_initiate/', {
                user_id: userId,
                plan: planId,
                currency_code: currency_code,
                currency_symbol: currency_symbol,
                movie: movie,
                series: series,
                credit_type: credit_type
                // payment_amount: payment_amount,
            });
            console.log("resData", resData)
            if (resData?.status == 200) {
                let sessionId = await resData?.data?.data?.payment_session_id
                setOrderId(resData?.data?.data?.order_id)
                ORDER = resData?.data?.data?.order_id
                let checkoutOptions = {
                    paymentSessionId: sessionId,
                    redirectTarget: "_modal",
                }

                cashfree.checkout(checkoutOptions)
                    .then(async (result) => {
                        console.log("payment initialize", result);

                        if (result?.error) {
                            alert(result?.error);
                            return; // Stop here if error
                        }
                        setResponseObject("Please wait");

                        try {
                            const resData = await axios.post(
                                'https://prmgold.thehnstore.com/api/payment_verify/',
                                {
                                    order_id: orderId || ORDER,
                                    user_id: userId,
                                    plan: planId,
                                    currency_code: currency_code,
                                    currency_symbol: currency_symbol,
                                    movie: movie,
                                    series: series,
                                    credit_type: credit_type
                                }
                            );

                            if (resData?.data?.status?.payment_status === "SUCCESS") {

                                navigation("/cfr-payment-success", { state: resData?.data, replace: true });
                            } else {
                                setResponseObject("Something went wrong");
                            }
                        } catch (err) {
                            console.error("Error verifying payment:", err);
                            setResponseObject("Server error while verifying payment");
                        }

                        setOrderId(null);
                        ORDER = "";
                    })
                    .catch((err) => {
                        console.error("Error initializing payment:", err);
                        alert("Unable to start payment process. Please try again.");
                    });




            }
            console.log("resData from api", resData);
        } catch (err) {
            console.error("Payment initiation error", err);
        }
    };

    return (
        <div>{responseObject || "CashfreeGold"}</div>
    );
}
